// const baseUrl = 'nh.e-health100.com:5601/iecsp';
// const baseUrl = '192.168.2.81:8013';
const baseUrl = 'bs.e-health100.com/iecsp';
const imgUrl = `https://zf.e-health100.com`;
// const baseUrl = 'bs.cigro.cn:440/iecsp';
// const baseUrl = '192.168.2.81:8013';
export { baseUrl, imgUrl }